<template>
  <div class="audio-playlist">
    <div class="player">
      <vue-plyr ref="player">
        <audio src="" />
      </vue-plyr>
    </div>
    <div>
      <div
        v-for="(v, i) in playlist"
        :key="i"
        :class="{'list-item': true, 'active': i == current}"
      >
        <button
          :class="{'playing': !paused}"
          @click="handlePlayClick(i)"
        >
          <svg
            v-if="paused || i != current"
            :data-playing="playing"
            :data-paused="paused"
            :data-i="i"
            :data-current="current"
          >
            <use xlink:href="#plyr-play" />
          </svg>
          <svg
            v-if="playing && i == current"
            :data-playing="playing"
            :data-paused="paused"
            :data-i="i"
            :data-current="current"
          >
            <use xlink:href="#plyr-pause" />
          </svg>
        </button>
        <span @click="setSource(i)">{{ v.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'

Vue.use(VuePlyr)

export default {
    name: 'AudioPlaylist',
    props: {
        playlist: {
            type: Array,
            default: () => []
        },
        startTrack: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            current: -1,
            ready: false,
            playing: false,
        }
    },
    computed: {
        paused() {
            return !this.playing
        },
        player() {
          return this.$refs.player.player
        }
    },
    mounted() {
        this.ready = !!this.player
        this.player.on('play', () => { this.onPlay() })
        // this.player.on('playing', () => { this.onPlay() })
        this.player.on('pause', () => { this.onPause() })
        if (this.playlist.length) {
            this.setSource(this.startTrack)
        }
    },
    methods: {
        onPlay() {
            this.playing = true
            this.$emit('event', {event: 'play', track: this.playlist[this.current]})
        },
        onPause() {
            this.playing = false
        },
        setSource(i) {
            if (this.current == i) {
                return
            }
            this.$refs.player.player.source = {
                type: 'audio',
                sources: [
                    {
                        src: this.playlist[i].file
                    }
                ]
            }
            this.current = i
        },
        playSource(i) {
            this.setSource(i)
            this.$refs.player.player.play()
        },
        handlePlayClick(i) {
            const isSame = i == this.current

            if (isSame) {
                this.$refs.player.player.togglePlay()
            } else {
                this.setSource(i)
                this.$refs.player.player.play()
            }

        }
    }
}
</script>

<style lang="scss">
.player {
    margin-bottom: 1rem;
}
.list-item {
    margin-bottom: 0.5rem;
    padding: 0.3rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
        padding: 1rem;
    }
    &.active {
        background: #ddd;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      height: 40px;
      width: 40px;
        color: #fff;
        svg {
            pointer-events: none;
            height: 18px;
            width: 18px;
            fill: #fff;
        }
    }

}
</style>